// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ONspBpk-{background:none;cursor:pointer;display:flex;font-size:.75rem;gap:1em;line-height:1.17}@media(hover:hover){.ONspBpk-:hover{opacity:.8}}@media(hover:none){.ONspBpk-:active{opacity:.8}}.ONspBpk-:active{opacity:.7}.ONspBpk- svg{height:.8em;width:.8em}.ONspBpk- svg *{stroke:currentColor}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": "ONspBpk-"
};
module.exports = ___CSS_LOADER_EXPORT___;
